import Entity from 'utilities/entity';

class Dream extends Entity {}

export default new Dream();
